import { render, staticRenderFns } from "./AddressCustomer.vue?vue&type=template&id=719154fb"
import script from "./AddressCustomer.vue?vue&type=script&lang=js"
export * from "./AddressCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports